(function () {
  'use strict';

  function formatTypes(types) {
    if (types.indexOf('shop') > -1 && types.indexOf('served') > -1) {
      return 'Pick Up a Bag &amp; Have a Cup';
    } else if (types.indexOf('shop') > -1) {
      return 'Pick Up a Bag';
    } else {
      return 'Have a Cup';
    }
  }

  function markerClass(types) {
    if (types.indexOf('shop') > -1 && types.indexOf('served') > -1) {
      return 'stockist-marker stockist-marker--both';
    } else if (types.indexOf('served') > -1) {
      return 'stockist-marker stockist-marker--served';
    }
    return 'stockist-marker stockist-marker--shop';
  }

  function createIcon(types) {
    return L.divIcon({
      className: '',
      html: '<div class="' + markerClass(types) + '"></div>',
      iconSize: [28, 28],
      iconAnchor: [14, 14],
      popupAnchor: [0, -18]
    });
  }

  /* Cluster badge: colour reflects what's inside, matching the single-pin key. */
  function createClusterIcon(cluster) {
    var children = cluster.getAllChildMarkers();
    var count = children.length;
    var hasShop = false;
    var hasServed = false;

    children.forEach(function (m) {
      var t = (m.options && m.options.stockistTypes) || [];
      if (t.indexOf('shop') > -1) { hasShop = true; }
      if (t.indexOf('served') > -1) { hasServed = true; }
    });

    var tone = (hasShop && hasServed) ? 'mixed' : (hasServed ? 'served' : 'shop');
    var size = count < 5 ? 'sm' : (count < 10 ? 'md' : 'lg');
    var px   = count < 5 ? 34   : (count < 10 ? 42   : 52);

    return L.divIcon({
      className: '',
      html: '<div class="stockist-cluster stockist-cluster--' + tone +
            ' stockist-cluster--' + size + '">' + count + '</div>',
      iconSize: [px, px],
      iconAnchor: [px / 2, px / 2]
    });
  }

  function buildMarker(s) {
    var marker = L.marker([s.lat, s.lng], {
      icon: createIcon(s.types),
      stockistTypes: s.types
    });
    marker.bindPopup(
      '<strong>' + s.name + '</strong>' +
      '<br>' + s.address +
      '<br><em>' + formatTypes(s.types) + '</em>'
    );
    return marker;
  }

  function init() {
    var mapEl = document.getElementById('stockist-map');
    if (!mapEl || typeof L === 'undefined' || typeof STOCKISTS === 'undefined') return;

    var map = L.map('stockist-map', {
      center: [54.54, -2.72],
      zoom: 9,
      scrollWheelZoom: false
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18
    }).addTo(map);

    /* Group nearby pins. Falls back to a plain layer if the plugin didn't load. */
    var clustered = typeof L.markerClusterGroup === 'function';
    var group = clustered
      ? L.markerClusterGroup({
          iconCreateFunction: createClusterIcon,
          maxClusterRadius: 50,
          showCoverageOnHover: false,
          spiderfyOnMaxZoom: true,      // separates pins sharing a postcode
          disableClusteringAtZoom: 15,
          spiderLegPolylineOptions: { weight: 2, color: '#000', opacity: 0.6 }
        })
      : L.layerGroup();

    group.addTo(map);

    var markers = STOCKISTS.map(function (s) {
      return { marker: buildMarker(s), types: s.types };
    });

    function render(filter) {
      var active = markers.filter(function (m) {
        if (filter === 'shop')   { return m.types.indexOf('shop') > -1; }
        if (filter === 'served') { return m.types.indexOf('served') > -1; }
        return true;
      }).map(function (m) { return m.marker; });

      group.clearLayers();
      if (clustered) {
        group.addLayers(active);           // bulk add is much faster
      } else {
        active.forEach(function (m) { group.addLayer(m); });
      }
    }

    render('all');

    var filterButtons = document.querySelectorAll('.stockist-filter-btn');
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.getAttribute('data-filter');
        filterButtons.forEach(function (b) {
          b.classList.remove('stockist-btn--primary', 'stockist-btn--secondary');
          b.classList.add('stockist-btn--outline');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.remove('stockist-btn--outline');
        this.setAttribute('aria-pressed', 'true');
        this.classList.add(filter === 'served' ? 'stockist-btn--secondary' : 'stockist-btn--primary');
        render(filter);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
